import * as Sentry from '@sentry/react';
Sentry.init({
  dsn: 'https://3651aa2cf43f82bdc7b3f93d324d668f@o4511268975345664.ingest.de.sentry.io/4511268978819152',
  environment: process.env.NODE_ENV,
  tracesSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary fallback={<div style={{padding:20}}>Bir hata oluştu, lütfen sayfayı yenileyin.</div>}>
    <App />
  </Sentry.ErrorBoundary>
);
